export default __webpack_public_path__ + "static/joko-app-screenshot-home-4-fr-d77da89b5290faf543c49c62cd812b15.webp";